import './SalesInfoPopup.scss';
import { useContext } from 'react';
import { ManualInputContext } from '../../context/context';
import { Tooltip } from 'primereact/tooltip';
import { IBarData } from './IBarData';

export interface ISalesInfoPopupProps {
	index: string;
	quarter: number;
	maxTotalSales: number;
	maxMarketSharePotential: number;
	bar1Data: IBarData;
	bar2Data: IBarData;
	bar3Data: IBarData;
	bar4Data: IBarData;
	product: string;
	productCategory: string;
}

const SalesInfoPopup = ({
	index,
	quarter,
	maxTotalSales,
	maxMarketSharePotential,
	bar1Data,
	bar2Data,
	bar3Data,
	bar4Data,
	product,
	productCategory
}: ISalesInfoPopupProps) => {
	const localContext = useContext(ManualInputContext);

	function showGraph() {
		localContext?.showGraphPopupWithData({
			maxTotalSales,
			maxMarketSharePotential,
			bar1Data,
			bar2Data,
			bar3Data,
			bar4Data,
			product,
			productCategory
		});
	}

	return (
		<Tooltip target={`#${index}`} autoHide={false} hideDelay={600}>
			<div className='sales-info-popup'>
				<div className='sales-info-popup__container'>
					<div className='sales-info-popup__legend'>
						<p className='sales-info-popup__legend-item'>
							TM Potential
						</p>
						<p className='sales-info-popup__legend-item sales-info-popup__legend-item--sales'>
							Sales graph
						</p>
					</div>

					<p className='sales-info-popup__quarter'>Q{quarter}</p>

					<div className='sales-info-popup__data'>
						<p className='sales-info-popup__data-item'>
							{maxMarketSharePotential}
						</p>
						<p className='sales-info-popup__data-item sales-info-popup__data-item--sales'>
							{maxTotalSales}
						</p>
					</div>
				</div>

				<div className='sales-info-popup__container'>
					<button
						className='sales-info-popup__btn'
						onClick={showGraph}
					>
						See graph
					</button>
				</div>
			</div>
		</Tooltip>
	);
};

export default SalesInfoPopup;
